import { useCallback, useMemo, useState } from 'react';
import Lightbox from '@components/Lightbox';
import { Picture } from '@ui';
import { videoPlayThumb } from '@images';
import './index.scss';

const ReviewAttachedFiles = ({ attachedFiles }) => {
  const [isOpenLightbox, setIsOpenLightbox] = useState(false);
  const [activeSlideNumber, setActiveSlideNumber] = useState(0);
  const onThumbClickHandler = useCallback(index => {
    setIsOpenLightbox(prev => !prev);
    setActiveSlideNumber(index + 1);
  }, []);
  const types = useMemo(
    () => attachedFiles.map(item => (item.isVideo ? 'video' : 'image')),
    [attachedFiles]
  );
  const sources = useMemo(
    () => attachedFiles.map(item => item.big),
    [attachedFiles]
  );

  return (
    <div className='ReviewAttachedFiles'>
      {attachedFiles.map((item, index) => (
        <div
          key={item.id}
          className={`ReviewAttachedFiles__file-wrapper${
            attachedFiles.length === index + 1
              ? ' ReviewAttachedFiles__file-wrapper--last'
              : ''
          }`}
        >
          {item.isVideo && (
            <div className='ReviewAttachedFiles__video-play-btn-wrapper'>
              <Picture
                className='ReviewAttachedFiles__video-play-btn'
                icon={videoPlayThumb}
                height='16'
              />
            </div>
          )}
          <img
            className='ReviewAttachedFiles__file'
            key={item.id}
            src={item.thumb}
            onClick={() => onThumbClickHandler(index)}
          />
        </div>
      ))}
      <Lightbox
        toggler={isOpenLightbox}
        sources={sources}
        slide={activeSlideNumber}
        types={types}
      />
    </div>
  );
};
export default ReviewAttachedFiles;
